import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { isArray, isString, filter, find, map, includes } from 'lodash-es';
import { useCallback, useState, useEffect, useRef } from 'react';
import Select, { components, } from 'react-select';
import dropDownIcon from '../../images/dropdown-button.svg';
export function SelectField(props) {
    const [isOpen, setIsOpen] = useState(false);
    const { id, value, placeholder, options, onChange, multiple } = props;
    const showValues = props.showValues === undefined ? true : props.showValues;
    const componentRef = useRef(null);
    const collapseHandler = useCallback((event) => {
        if (componentRef.current && !componentRef.current.contains(event.target) && isOpen) {
            setIsOpen(false);
        }
    }, [isOpen, setIsOpen, componentRef]);
    useEffect(() => {
        document.addEventListener('mousedown', collapseHandler);
        return () => document.removeEventListener('mousedown', collapseHandler);
    }, [collapseHandler]);
    const handleChange = useCallback((valueType, actionMeta) => {
        if (isArray(valueType)) {
            onChange(map(valueType, 'value').join(','));
            return;
        }
        if (valueType !== null && 'value' in valueType && 'label' in valueType) {
            onChange(valueType.value);
        }
    }, [onChange, multiple]);
    const IndicatorSeparator = useCallback(() => null, []);
    const ClearIndicator = useCallback(() => null, []);
    const MultiValueContainer = useCallback((MultiValueContainerProps) => {
        const selectedValues = MultiValueContainerProps.selectProps.value;
        if (selectedValues && isArray(selectedValues)) {
            return selectedValues[selectedValues.length - 1].label ===
                MultiValueContainerProps.data.label ?
                MultiValueContainerProps.data.label :
                MultiValueContainerProps.data.label + ', ';
        }
        else
            return '';
    }, []);
    const Option = useCallback((OptionProps) => (_jsx(components.Option, { ...OptionProps, children: _jsxs("div", { className: "dropdown-option", children: [OptionProps.data.label, _jsx("span", { className: classnames('checkbox', {
                        checked: includes(value.split(','), OptionProps.data.value),
                    }) })] }) })), [value]);
    const Menu = (props) => {
        return (_jsx("div", { style: {
                marginTop: -4,
                position: 'absolute',
                zIndex: 2,
                right: 0,
                minWidth: "300px"
            }, className: "multi-select", ...props }));
    };
    const Blanket = (props) => (_jsx("div", { style: {
            bottom: 0,
            left: 0,
            top: 0,
            right: 0,
            position: 'fixed',
            zIndex: 1,
        }, className: "blanket", ...props }));
    const Dropdown = ({ children, isOpen, target, onClose, }) => (_jsxs("div", { style: { position: 'relative', height: "100%" }, children: [target, isOpen ? _jsx(Menu, { children: children }) : null, isOpen ? _jsx(Blanket, { onClick: onClose }) : null] }));
    const Svg = (p) => (_jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", focusable: "false", role: "presentation", ...p }));
    const DropdownIndicator = () => (_jsx("div", { style: { height: 24, width: 32 }, children: _jsx(Svg, { children: _jsx("path", { d: "M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z", fill: "currentColor", fillRule: "evenodd" }) }) }));
    const ChevronDown = () => (_jsx(Svg, { style: { marginRight: -6 }, children: _jsx("path", { d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z", fill: "currentColor", fillRule: "evenodd" }) }));
    const selectStyles = {
        control: (provided) => ({
            ...provided,
            minWidth: 240,
            margin: 8,
        }),
        menu: () => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
    };
    if (multiple) {
        return (_jsx(Dropdown, { isOpen: isOpen, onClose: () => setIsOpen(false), target: _jsxs("div", { ref: componentRef, className: "select-drop-down-trigger", onClick: () => setIsOpen((prev) => !prev), children: [_jsx("span", { className: "ellipses", children: value ? value && filter(options, option => includes(value.split(','), option.value)).map(option => option.label).join(', ') : placeholder }), _jsx("img", { src: dropDownIcon, alt: "" })] }), children: _jsx(Select, { id: id, className: "form-select", classNamePrefix: "form-select", autoFocus: true, backspaceRemovesValue: false, components: {
                    Option,
                    IndicatorSeparator,
                    ClearIndicator,
                    MultiValueContainer,
                    DropdownIndicator
                }, controlShouldRenderValue: showValues, hideSelectedOptions: false, isClearable: false, menuIsOpen: true, onChange: handleChange, options: options, placeholder: placeholder, styles: selectStyles, tabSelectsValue: false, value: filter(options, option => includes(value.split(','), option.value)), isMulti: true }) }));
    }
    return (_jsx(Select, { id: id, className: "form-select", classNamePrefix: "form-select", value: isString(value) ? find(options, { value }) : undefined, placeholder: placeholder, onChange: handleChange, options: options, components: { IndicatorSeparator, ClearIndicator, DropdownIndicator }, hideSelectedOptions: false, controlShouldRenderValue: showValues }));
}
